import { Select } from '@hakimo-ui/hakimo/ui-elements';
import { InputField } from '@hakimo-ui/shared/ui-base';

interface Props {
  mode: 'create' | 'edit';
  name: string;
  description: string;
  locationId: string;
  locationOptions?: { id: string; name: string }[];
  onNameChange?: (value: string) => void;
  onLocationChange?: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

function CameraGroupFormCard({
  mode,
  name,
  description,
  locationId,
  locationOptions = [],
  onNameChange,
  onLocationChange,
  onDescriptionChange,
}: Props) {
  type LocationOption = { id: string; name: string };

  const selectedLocation =
    locationOptions.find((l) => l.id === locationId) ?? null;
  return (
    <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 rounded-lg p-4">
      <div className="space-y-6">
        <div>
          <p className="dark:text-dark-secondary-text text-onlight-text-3 mb-1">
            Location{' '}
            {mode === 'create' && <span className="text-alert-500">*</span>}
          </p>

          {mode === 'create' ? (
            <Select<LocationOption>
              value={selectedLocation}
              placeholder="Select location"
              displayValue={(item) => item?.name ?? ''}
              getItems={(query) =>
                locationOptions.filter((l) =>
                  l.name.toLowerCase().includes(query.toLowerCase())
                )
              }
              onChange={(item) => onLocationChange?.(item?.id ?? '')}
            />
          ) : (
            <p className="dark:text-dark-text text-onlight-text-1 mt-1">
              {locationOptions.find((l) => l.id === locationId)?.name}
            </p>
          )}
        </div>

        <div>
          <p className="dark:text-dark-secondary-text text-onlight-text-3 mb-1">
            Name <span className="text-alert-500">*</span>
          </p>

          <InputField
            value={name}
            type="text"
            placeholder="Enter the camera group name"
            onChange={(e) => onNameChange?.(e.target.value)}
          />
        </div>

        <div>
          <p className="dark:text-dark-secondary-text text-onlight-text-3 mb-1">
            Description
          </p>
          <InputField
            value={description}
            type="text"
            placeholder="Comments about this camera group"
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default CameraGroupFormCard;
